export default {
  common: {
    unsaved: 'You have unsaved changes. Are you sure you want to discard them?',
    nonNegative: "Number can't be negative",
    saveStatusError: 'There was an error while trying to save the changes.',
    saveStatusSuccess: 'Changes saved!',
    orderNoActive: 'No active order.',
    noPriceAvailable: 'No price available',
    noPriceAvailableError:
      "We can't retrieve the price at the moment. If the problem persist please don't hesitate to contact us",
    noContent: 'Oops. Nothing to display.',
    exporting: 'Generating the file. This might take a while...',
  },
  createOrder: {
    fail: 'There was an error while trying to create the order.',
    success: 'Order created successfully!',
  },
  activeOrder: {
    fail: 'There was an error while trying to activate the order.',
    success: 'Order activated successfully!',
    prompt: 'Do you want to save the current order?',
  },
  addItemToOrder: {
    addTitle: 'Add to order',
    editTitle: 'Edit order',
    currentLimitDescription: 'Current limit for this product',
    currentLimitWithPrevQty: '(on top of the items included in your order)',
    errorWhileTryingToAdd:
      'There has been an error while trying to add the item to the order.',
    casesRequired: 'Cases is required',
    bottlesRequired: 'Bottles is required',
    quantityExceeded: 'Quantity exceeded',
    itemIsAddedToOrder: 'This item is added to the order',
    limitReached:
      'Your order includes all the items of this product we have in stock',
    aboveLimit: 'You are currently above the limit by:',
    noStock: 'No available inventory',
    loadingSettings: 'Retrieving inventory status',
    validatingDataAgainstServer: 'Saving...',
    fail: 'There was an error while trying to add the item to the active order',
    success: 'Item added successfully!',
    editFail: 'There was an error while trying to edit the item',
    editSuccess: 'Item edited successfully!',
    removeSuccess: 'Item removed successfully!',
    removeFail: 'There was an error while trying to remove the item',
  },
  editOrder: {
    fail: 'There has been an error while trying to save the order',
  },
  editOrderNotes: {
    fail: 'There was an error while trying to save the notes',
    success: 'Notes successfully updated!',
  },
  removeOrder: {
    prompt: 'Are you sure you want to remove the order?',
    fail: 'There was an error while trying to remove the order',
    success: 'Order successfully removed!',
  },
  shipAll: {
    prompt: 'Are you sure you want to add all the items?',
    fail: 'There was an error while trying to add all the items',
    success: 'Items successfully added!',
  },
  order: {
    noContent: 'No items have been added to the order yet',
    det: {
      update:
        'Rows marked in orange no longer contain valid quantities. Please use the "Edit Item" to update the quantity',
      remove: 'Rows marked in red are no longer valid for this Order Type.',
      outofstock: 'Rows marked in gray ran out of stock.',
      unsavedchanges:
        'Changes made to the order will remain unsaved until you click on "Save order"',
    },
  },
  transmitOrder: {
    loading: 'Transmitting...',
    prompt:
      'Are you sure you want to transmit the order? You will not be able to edit it later.',
    fail: 'There has been an error while trying to transmit the order',
    success: 'Order successfully transmited!',
  },
  global: {
    anouncements: {
      orderTransmitted: 'The order has been transmitted successfully!',
    },
  },
  export: {
    limitExceeded:
      'Sorry, the maximum number of rows you can export is 360,000. Please filter your request further.',
  },
};
